<template>
  <el-submenu
    v-if="hasPermission('feature_group:pricing')
      || hasPermission('role:vendor')
      || hasPermission('role:super_admin')
      || hasPermission('role:admin')
      || hasPermission('role:device_install_contractor')
      || hasPermission('feature_group:users')
      || hasPermission('feature_group:management')
    || hasSidebarSubmenu('Management')"
    class="side-navigator__submenu"
    index="management">
    <template slot="title">
      <navigation-icon
        name="users"/>
      Management
    </template>
    <el-menu-item
      v-if="hasPermission('feature_group:users') && hasPermission('feature:users:users')"
      class="side-navigator__menu-item"
      index="/users">
      <template slot="title">
        Users
      </template>
    </el-menu-item>
    <el-menu-item
      v-if="hasSidebarItem('Advertisers')"
      index="/advertisers"
      class="side-navigator__menu-item">
      Advertisers
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stores:stores')"
      class="side-navigator__menu-item"
      index="/stores">
      Stores
    </el-menu-item>
    <el-menu-item
      v-if="hasSidebarItem('Store Search')"
      index="/pricing/stores"
      class="side-navigator__menu-item">
      Store Search
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:banners')"
      index="/banners"
      class="side-navigator__menu-item">
      Banners
    </el-menu-item>
  </el-submenu>
</template>

<script>
import NavigationIcon from './NavigationIcon'

export default {
  name: 'ManagementNavigationGroup',
  components: {
    NavigationIcon,
  },
  props: {
    sidebarEntries: {
      type: Array,
      required: false,
      default: null,
    },
  },
  methods: {
    hasSidebarSubmenu(name) {
      return this.sidebarEntries
        && this.sidebarEntries.some(e => e.name === name)
    },
    hasSidebarItem(name) {
      return this.sidebarEntries
        && this.sidebarEntries.some(e => e.children.some(c => c.name === name))
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/ManagementNavigationGroup.vue